<template>
  <div>
    <SerialPack :url="url" cur-class="super_serial_pack2" />
  </div>
</template>

<script>
import SerialPack from '@/views/config/activity-auxiliary/serialPack.vue'
export default {
  name: 'SuperSerialPack2',
  components: {
    SerialPack
  },
  data() {
    return {
      url: '/config/activity-auxiliary/serialPack2'
    }
  }
}
</script>

<style scoped>

</style>
